import clsx from "clsx";
import styles from "./ReferralTermAndConditions.module.scss";

interface ReferralTermsArProps {
  referralPayout: Money;
  withdrawalMethods: WithdrawalMethods;
}

const ReferralTermsAr: React.FC<ReferralTermsArProps> = ({
  referralPayout,
  withdrawalMethods,
}) => {
  return (
    <main className={clsx(styles.container, styles.rtl)}>
      <h1>شروط برنامج الإحالة</h1>
      <strong>
        المقصود بالإحالة المؤهلة هو حالة الإحالة الخاصة بك بعد استيفاء الشروط
        التالية:
      </strong>
      <ol>
        <li> استخدام رمز الإحالة الخاص بك عند تسجيل الدخول</li>
        <li>
          الحصول على مبلغ محدد للاسترداد النقدي المؤكد عن طريق التسوق عبر شوب
          كاش
        </li>
      </ol>

      <strong>تفاصيل أوفى حول النقاط السابقة:</strong>
      <ol>
        <li> على صديقك التسجيل باستخدام الرمز الخاص بك</li>
        <li>
          يجب أن تكون عملية الشراء الأولى للإحالات أمرًا شرعيًا غير قابل للتكديس
          مع العروض الترويجية للعملاء الجدد الآخرين
        </li>
        <li>
          الطلبات التي لا تحصل على استرداد نقدي ، أو أي طلبات تم إلغاؤها أو
          استردادها أو استبدالها لن تكون مؤهلة لهذا البرنامج.
        </li>
        <li>
          سيتم تتبع المكافأة التي تبلغ {referralPayout?.currencyCode}{" "}
          {referralPayout?.amount} درهم إماراتيًا عندما يقوم صديقك بالتسجيل.
          ستتم إضافة مكافأتك إلى حساب ShopCash الخاص بك فقط عندما يربح صديقك
          الحد الأدنى من الكاش باك المؤكد المذكور.
        </li>

        <li>
          تحتفظ ShopCash بالحق وفقًا لتقديرها المطلق في تعديل وتغيير الشروط
          والأحكام كما هو موضح أعلاه ، وكذلك استبعاد أي مستخدم في أي وقت.
        </li>
        <li>
          لسحب الاسترداد النقدي ، يجب أن تكون مستخدمًا نشطًا بحد أدنى من الكاش
          باك المؤكد {withdrawalMethods?.bankTransfer?.minimum?.currencyCode}{" "}
          {withdrawalMethods?.bankTransfer?.minimum?.amount} درهم إماراتيًا من
          التسوق عبر ShopCash
        </li>
      </ol>

      <h3>القيود والمحظورات</h3>
      <strong>
        فيما يلي قائمة غير شاملة بالأنشطة غير المسموح بها والتي ستحرمك من كسب
        مكافآت الإحالة:
      </strong>
      <p>الإحالة الذاتية ،</p>
      <p>
        نشر رمز الإحالة الخاص بك على Facebook أو صفحة المنتدى الخاصة بتاجر
        ShopCash ،
      </p>
      <p>
        وضع شعاراتنا أو ذكر علاماتنا التجارية أو أسماءنا التجارية في أي نص إعلان
        أو ملحقات أو لافتة إعلانية ،
      </p>
      <p>
        عروض تسعير الكلمات الرئيسية لغرض توليد حركة مرور إلى الصفحات التي تحتوي
        على رمز الإحالة الخاص بك ، و
      </p>
      <p>
        أي نشاط مشابه تحدده ShopCash وفقًا لتقديرها الخاص لا يتوافق مع الغرض من
        برنامج إحالة صديق لـ ShopCash.
      </p>

      <p>
        تحتفظ شوب كاش بالحق في تغيير شروط وأحكام هذا العرض الترويجي. أي انتهاك
        للشروط والأحكام المذكورة أعلاه سيؤدي إلى خسارة جميع المكافآت. قد يؤدي
        تكرار المخالفات إلى إغلاق حساب المستخدم على شوب كاش. أنت المسؤول عن أية
        ضرائب سارية. برنامج الإحالة هذا متاح فقط للأفراد ممن تزيد أعمارهم عن 18
        عامًا.
      </p>
      <h3>في الختام</h3>
      <p>
        نحتفظ لأنفسنا بحق تعليق برنامج الإحالة أو إنهائه أو تغيير شروطه في أي
        وقت ولأي سبب وفق تقديرنا الخاص.
      </p>
    </main>
  );
};

export default ReferralTermsAr;
